
<template>
  <div class="padded">
    <equip-table
      title="Own Power"
      title-heading="h4"
      :site-id="this.siteId"
      :site-data="siteData"
      :owner-id="this.ownerId"
      :show-qr-code="showQrCode"
      filter-col="category"
      filter-val="Power" />
  </div>
</template>

<script>

import EquipTable from '@/components/assets/EquipTable'

export default {

  components: {
    EquipTable
  },

  props: {
    siteId: {
      type: Number,
      required: true
    },

    siteData: {
      type: Object
    },

    ownerId: {
      type: Number,
      default: null
    },

    showQrCode: {
      type: Boolean,
      default: false
    }
  }

}

</script>
